import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface AddDriverIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function AddDriverIcon({ color = RoutalPalette.secondary60, style = {}, ...props }: AddDriverIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 29.42 20.99" style={{ height: `20px`, ...style }}>
      <g>
        <g>
          <g>
            <path
              d="M25.5265 11.3527L22.8491 6.07251C22.3241 5.0449 21.2846 4.3999 20.1191 4.3999H10.6903C10.6903 4.48736 10.7008 4.56388 10.7008 4.65134C10.7008 4.95744 10.6693 5.25261 10.6378 5.54777H16.7382V10.183H7.78185C6.81587 10.817 5.6609 11.1997 4.43242 11.1997C4.33792 11.1997 4.23293 11.1997 4.13843 11.1887V15.7802C4.13843 16.5455 4.74742 17.1577 5.5034 17.1577H6.03889C6.30138 18.5788 7.54036 19.6611 9.04183 19.6611C10.5433 19.6611 11.7823 18.5788 12.0448 17.1577H16.1712C16.4337 18.5788 17.6727 19.6611 19.1741 19.6611C20.6756 19.6611 21.9146 18.5788 22.1771 17.1577H24.235C24.991 17.1577 25.6 16.5345 25.6 15.7802V11.6151C25.6 11.5276 25.579 11.4402 25.537 11.3637L25.5265 11.3527ZM9.04183 18.557C7.93935 18.557 7.03637 17.6824 7.03637 16.6001C7.03637 15.5179 7.93935 14.6433 9.04183 14.6433C10.1443 14.6433 11.0473 15.5179 11.0473 16.6001C11.0473 17.6824 10.1443 18.557 9.04183 18.557ZM19.1636 18.557C18.0611 18.557 17.1582 17.6824 17.1582 16.6001C17.1582 15.5179 18.0611 14.6433 19.1636 14.6433C20.2661 14.6433 21.1691 15.5179 21.1691 16.6001C21.1691 17.6824 20.2661 18.557 19.1636 18.557ZM17.8722 10.183V5.53684H19.8461C21.4211 5.53684 21.7256 6.28022 22.1981 7.20945C22.9331 8.66342 23.3215 9.41774 23.6995 10.183H17.8722Z"
              fill={color}
            />
            <path
              d="M7.72933 4.10475H4.94689V1.20774C4.94689 0.901639 4.71589 0.661133 4.4219 0.661133C4.12791 0.661133 3.89691 0.901639 3.89691 1.20774V4.10475H1.12497C0.830971 4.10475 0.599976 4.34525 0.599976 4.65135C0.599976 4.95745 0.830971 5.19796 1.12497 5.19796H3.90741V8.09496C3.90741 8.40106 4.1384 8.64157 4.4324 8.64157C4.72639 8.64157 4.95739 8.40106 4.95739 8.09496V5.19796H7.73983C8.03383 5.19796 8.26482 4.95745 8.26482 4.65135C8.26482 4.34525 8.03383 4.10475 7.73983 4.10475H7.72933Z"
              fill={color}
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath>
          <rect width="26" height="20" fill={RoutalPalette.neutral00} transform="translate(0.5 0.441162)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
